/* eslint-disable class-methods-use-this */
import {GameDataFirstGameState} from '@colonist/game-state-types'
import {UIMSceneEnum} from '../../../shared/enums/UIMSceneEnums'
import {GameStateEnums, NetworkEnums} from '../../../shared/GameEnums'
import {MatchmakingStatusUpdate} from '../../../shared/matchmaking/MatchmakingInterfaces'
import {SocketDataTypes} from '../../../shared/SocketDataTypes'
import {SocketLobbySend} from '../../shared/scripts/socket/SocketLobbySend'
import {SocketActionController} from '../../shared/scripts/socket/SocketActionController'
import {UIGameManager} from '../../shared/scripts/ui_game/UIGameManager'
import {UIUrlController} from '../../shared/scripts/ui_html/UIUrlController'
import {UIMManager} from './ui_html/UIMManager'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {BaseError} from '../../../shared/errors/BaseError'
import {logError} from '../../shared/scripts/ui_utils/Utils'
import {UIMGeneralServicesController} from './UIMGeneralServicesController'

export class UIMSocketEventHandler extends SocketActionController {
    readonly uiGameManager: UIGameManager
    private readonly uiManager: UIMManager

    constructor(uiGameManager: UIGameManager, uiManager: UIMManager, generalServicesController: UIMGeneralServicesController) {
        super(generalServicesController)
        this.uiGameManager = uiGameManager
        this.uiManager = uiManager
    }

    onStateSessionState() {
        const isAccessGameFromLinkHandledByRoom = this.uiManager.createRoomController.isUserOnCreateRoomFlow()
        if(!isAccessGameFromLinkHandledByRoom) {
            UIUrlController.accessGameFromLink(async(roomId) => {
                await SocketLobbySend.accessGameFromLink(roomId)
            })
        }
    }

    onConnectionEstablished(data: GameDataFirstGameState) {
        this.uiManager.fullscreenPageController.closeAllPages()
        this.uiManager.sceneController.loadScene(UIMSceneEnum.Game)
        window.location.hash = data.gameSettingId
    }
    onStateInitialPlacement() {
        this.uiManager.sceneController.loadScene(UIMSceneEnum.Game)
    }
    onMatchmakingUpdate(matchmakingStatusUpdate: MatchmakingStatusUpdate) {
        const matchmakingSelectionController = this.uiManager.mainpageController.bodyController.homepageController.matchmakingController
        matchmakingSelectionController.updateMatchmakingStatus(matchmakingStatusUpdate)
    }
    onMatchmakingError(error: BaseError) {
        this.uiManager.mainpageController.bodyController.homepageController.showMatchmakingError(error)
    }

    onMatchmakingDisableAdblock() {
        logError('onMatchmakingDisableAdblock', ['No ad blocker on mobile'])
    }
    onChannelRoomUpdate(roomData: SocketDataTypes.ChannelRoomUpdate) {
        logError('onChannelRoomUpdate', ['No channel room update on mobile'])
    }

    onRoomListUpdate(data: NetworkEnums.RoomListUpdateData) {
        this.uiManager.mainpageController.bodyController.lobbyController.updateRoomList(data)
    }
}
